export default function maskText(text, maskStartIndex) {
  return text
    .split(" ")
    .map((word) => {
      // Sayıları kontrol et
      if (!isNaN(word)) {
        return "*".repeat(word.length);
      } else {
        // Belirtilen harften sonra maskelamaya başla
        if (word.length > maskStartIndex) {
          return (
            word.substring(0, maskStartIndex) +
            "*".repeat(word.length - maskStartIndex)
          );
        } else {
          // Kelime uzunluğu maskStartIndex'ten kısa veya eşitse, kelimeyi olduğu gibi bırak
          return word;
        }
      }
    })
    .join(" ");
}



// WEBPACK FOOTER //
// ./src/helpers/maskText.js